import CheckCircleIcon from '@heroicons/react/20/solid/CheckCircleIcon.js';
import ExclamationTriangleIcon from '@heroicons/react/20/solid/ExclamationTriangleIcon.js';
import InformationCircleIcon from '@heroicons/react/20/solid/InformationCircleIcon.js';
import XCircleIcon from '@heroicons/react/20/solid/XCircleIcon.js';

/** The one glyph per status, shared by every component that marks one (Callout, Toast). */
export const STATUS_ICONS = {
  info: InformationCircleIcon,
  success: CheckCircleIcon,
  warning: ExclamationTriangleIcon,
  error: XCircleIcon,
} as const;
